import React, { Component } from "react"
import { Router as RouterRR } from "react-router"
import T from "prop-types"

const PropTypes = {
  getLocation: T.func.isRequired,
  history: T.object.isRequired,
  onLocationChanged: T.func.isRequired,
  children: T.node,
  store: T.shape({
    getState: T.func.isRequired,
    subscribe: T.func.isRequired,
  }).isRequired,
}

const isDevelopment = process.env.NODE_ENV === "development"

class Router extends Component {
  constructor(props, context) {
    super(props)

    this.inTimeTravelling = false

    const { store } = props

    if (isDevelopment) {
      // Subscribe to store changes
      this.unsubscribe = store.subscribe(() => {
        // Extract store's location
        const {
          pathname: pathnameInStore,
          search: searchInStore,
          hash: hashInStore,
        } = props.getLocation(store.getState())
        // Extract history's location
        const {
          pathname: pathnameInHistory,
          search: searchInHistory,
          hash: hashInHistory,
        } = props.history.location

        // If we do time travelling, the location in store is changed but location in history is not changed
        if (
          pathnameInHistory !== pathnameInStore ||
          searchInHistory !== searchInStore ||
          hashInHistory !== hashInStore
        ) {
          this.inTimeTravelling = true
          // Update history's location to match store's location
          props.history.push({
            pathname: pathnameInStore,
            search: searchInStore,
            hash: hashInStore,
          })
        }
      })
    }

    // Listen to history changes
    this.unlisten = props.history.listen((location, action) => {
      // Dispatch onLocationChanged except when we're in time travelling
      if (!this.inTimeTravelling) {
        props.onLocationChanged(location, action)
      } else {
        this.inTimeTravelling = false
      }
    })

    props.onLocationChanged(props.history.location, props.history.action)
  }

  componentWillUnmount() {
    if (isDevelopment) {
      this.unsubscribe()
    }

    this.unlisten()
  }

  render() {
    let { history, children } = this.props

    return <RouterRR history={history}>{children}</RouterRR>
  }
}

Router.propTypes = PropTypes

export default Router
